exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-btn-blue[data-v-7cd0881e]{font-family:DMSans-Medium;border-radius:0.14rem}\n", ""]);

// exports
